/* src/app/quickbooks/send-hours/send-hours-container/send-hours-container.component.scss */
ef-send-hours-presenter {
  flex-basis: 50vw;
  padding: 1em;
}
ef-send-bill-presenter {
  flex-basis: 50vw;
  padding: 1em;
}
body#themeTag :host ::ng-deep .p-message .p-message-wrapper {
  padding: 0rem 1rem;
}
body#themeTag :host ::ng-deep p-messages {
  max-height: 4.15rem;
  overflow: visible;
}
/*# sourceMappingURL=send-hours-container.component.css.map */
